import React, { useEffect, useState, useCallback } from "react";

import { CircularProgress, Box } from "@mui/material";
import Alert from "@mui/material/Alert";

// components
import SearchInput from "../../components/common/searchInput";

import { getAllUsers } from "../../setup/api/services/user";
import { usersList, ALERT } from "./constants";

import UserListItem from "./UserListItem";

import "./styles.css";
import styles from "./user_management_styles.module.scss";
import { ALERTMESSAGE } from "../../enums";
import Paginations from "../../components/common/Pagination/paginations";

interface UsersManagementProps {
  isAdmin?: boolean;
}

const UsersManagement = ({ isAdmin }: UsersManagementProps) => {
  const [page, setPage] = useState(1);
  const [pagesCount, setPagesCount] = useState(1);

  const pageSize = 25;
  const [loading, setLoading] = useState<boolean>(false);
  const [listUsers, setListUsers] = useState([]);
  const [alert, setAlert] = useState<ALERT>(ALERT.NONE);
  const [searchValue, setSearchValue] = useState("");

  const fetchUsersList = useCallback(
    async (page) => {
      try {
        const response = await getAllUsers(page - 1, pageSize, searchValue);
        setListUsers(response.data.content);
        setPagesCount(response.data.totalPages);
      } catch (error) {
        console.error;
      }
    },
    [searchValue]
  );

  const handleHashChange = useCallback(() => {
    setPage(Number(window.location.hash.replace(/#/g, "")));
    fetchUsersList(Number(window.location.hash.replace(/#/g, "")))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [fetchUsersList]);

  useEffect(() => {
    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [handleHashChange]);

  useEffect(() => {
    let pageNumber = 1;
    if (window.location.hash) {
      pageNumber = Number(window.location.hash.replace(/#/g, ""));
    }
    setPage(pageNumber);
  }, []);

  useEffect(() => {
    try {
      fetchUsersList(page);
    } catch (error) {
      console.error(error);
    }
  }, [fetchUsersList, page, searchValue]);

  const handlePaginationChange = (value: number) => {
    window.location.hash = `${value}`;
    setLoading(true);
  };

  if (loading)
    return (
      <Box className="container center">
        <CircularProgress />
      </Box>
    );

  return (
    <div className={styles["page_layout"]}>
      {alert !== ALERT.NONE && alert !== ALERT.SUCCESS && (
        <Alert severity={"error"}>{ALERTMESSAGE.ERROR}</Alert>
      )}
      {alert === ALERT.SUCCESS && (
        <Alert severity={"success"}>{ALERTMESSAGE.SUCCESS}</Alert>
      )}
      <h1>{isAdmin ? usersList.WAFFY_USERS : usersList.USERS}</h1>
      <div className={styles.header_container}>
        <h3>{usersList.USERS_LIST}</h3>
        <SearchInput
          dir="ltr"
          placeholder={usersList.FIND_A_USER}
          value={searchValue}
          handleChange={(event) => {
            setSearchValue(event.target.value);
          }}
        />
      </div>
      <table className={styles.table}>
        <tr className={styles.table_header}>
          <th className={styles.hint}>{usersList.CUSTOMER_NAME}</th>
          <th className={styles.hint}>{usersList.MOBILE_NUMBER}</th>
          <th className={styles.hint}>
            {isAdmin ? usersList.PREACH : usersList.DOCUMENTATION}
          </th>
          <th className={styles.hint}>{usersList.THE_CONDITION}</th>
          <th className={styles.hint}>{usersList.DATE_CREATED}</th>
          <th className={styles.hint}></th>
          <th className={styles.hint}></th>
        </tr>
        <tbody className={styles.table_body}>
          {listUsers.map((userItem, index) => (
            <UserListItem
              key={index}
              item={userItem}
              fetchUsersList={fetchUsersList}
              page={page}
              alert={setAlert}
              loading={setLoading}
            />
          ))}
        </tbody>
      </table>

      <>
        <div className={listUsers.length ? "paginatorContainer" : "hide"}>
          <Paginations
            pagesCount={pagesCount}
            length={pagesCount}
            page={page}
            handlePaginationChange={handlePaginationChange}
          />
        </div>
      </>
    </div>
  );
};
export default UsersManagement;
